import {
  DetailedHTMLProps,
  forwardRef,
  HTMLAttributes,
  ReactNode,
} from "react";
import { FEATURE_FLAGS } from "@/types/v2";
import { useFeature } from "@/hooks/useFeatures";

// Feature component to conditionally render children based on feature flags
export const FeatureFlagged = forwardRef<
  HTMLDivElement,
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    children: ReactNode;
    feature: FEATURE_FLAGS;
    enabled?: boolean;
  }
>(({ children, feature, enabled = true, ...props }, ref) => {
  const isFeatureEnabled = useFeature(feature) && enabled;

  if (!isFeatureEnabled) {
    return null;
  }

  return (
    <div ref={ref} {...props}>
      {children}
    </div>
  );
});

FeatureFlagged.displayName = "FeatureFlagged";
